import { css } from 'styled-components';

const focusContainer = ({ inset, within, visible } = {}) => (...code) => {
    return css `
      &:focus${within && '-within'}${visible && '-visible'} {
        outline: transparent;
        box-shadow: ${({ theme }) => css `
            ${inset
        ? `inset 0 0 0 2px ${theme.olist.color.neutral.strong}`
        : `0 0 0 1px ${theme.olist.color.neutral.softest}, 0 0 0 3px ${theme.olist.color.neutral.strong}`}
          `};
        ${css(...code)}
      }
    `;
};

export { focusContainer };
